const FacebookIcon = ({ size = 16, color = "currentColor" }) => (
  <svg
    viewBox="0 0 10 20"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
  >
    <path d="M6.821282,20 L6.821282,11 L9.553693,11 L10,7 L6.821282,7 L6.821282,5.052 C6.821282,4.022 6.847593,3 8.286884,3 L9.744689,3 L9.744689,0.14 C9.744689,0.097 8.492497,0 7.225687,0 C4.580004,0 2.923407,1.657 2.923407,4.7 L2.923407,7 L0,7 L0,11 L2.923407,11 L2.923407,20 L6.821282,20 Z" />
  </svg>
);

export default FacebookIcon;